import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuditLogViewModel } from "../features/audit-log/audit-log-viewmodel";
import { OperationsViewModel } from "../features/operations/operations-viewmodel";
import { RegistrationsViewModel } from "../features/registrations/registrations-viewmodel";
import { UserIdViewModel } from "../features/user-id/user-id-viewmodel";
import { getAppRouteFromPathname } from "../routes/routes";
import { ViewModelContainer } from "../viewmodel/viewmodel";
export const RouteChangeScript = () => {
    const location = useLocation();
    const locationState = location.state ?? {};
    useEffect(() => {
        const provider = ViewModelContainer.getInstance();
        const routeWithExtras = getAppRouteFromPathname(location.pathname);
        const userId = provider.getViewModel(UserIdViewModel).userId;
        if (routeWithExtras?.route) {
            const route = routeWithExtras?.route;
            provider.getViewModel(UserIdViewModel).notifyLocationChanged(route);
            provider.getViewModel(RegistrationsViewModel).notifyLocationChanged(route, {
                userId,
                uuid: routeWithExtras?.uuid
            });
            provider.getViewModel(OperationsViewModel).notifyLocationChanged(route, {
                userId,
                filterRegId: locationState?.filterRegId ?? "",
                uuid: routeWithExtras?.uuid
            });
            provider.getViewModel(AuditLogViewModel).notifyLocationChanged(route, {
                userId,
            });
        }
    }, [location]);
    return null;
};
